<template>
  <div class="notification">
    <form @submit.prevent="generateLink">
      <label for="timeInput">Tiempo (en minutos):</label>
      <input
        id="timeInput"
        type="number"
        v-model="time"
        :min="30"
        :max="1440"
        required
      />
      <button type="submit" :disabled="loading">Generar Link</button>
    </form>

    <div v-if="qr && videoUrl" class="result">
      <img :src="qr" alt="QR Code" />
      <div class="copy-container">
        <button @click="copyToClipboard">Copiar Link</button>
        <v-icon v-if="copied" color="green">mdi-check-circle</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { shareVideoUrlService } from '@/services/shareVideoUrl';

export default {
  name: "SimpleNotification",
  props: {
    token: {
      type: String,
      required: true
    },
    video_url: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      time: 30,
      qr: null,
      videoUrl: null,
      loading: false,
      copied: false
    };
  },
  methods: {
    async generateLink() {
      this.loading = true;
      try {
        const result = await shareVideoUrlService(this.video_url, this.token, this.time);
        console.warn(result);
        this.qr = result.qr;
        this.videoUrl = result.video_url;
      } catch (error) {
        console.error("Error generating link:", error);
      } finally {
        this.loading = false;
      }
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.videoUrl).then(() => {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2500); // Reset icon after 2.5 seconds
      });
    }
  }
};
</script>

<style scoped>
.notification {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 5px;
  background-color: #353535;
  height: auto;
  width: auto;
}

.notification img {
  max-width: 250px;
  max-height: 250px;
  margin: 10px 0;
}

form {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

form label {
  margin-bottom: 5px;
}

form input {
  margin-bottom: 10px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 3px;
}

form button {
  padding: 5px 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}

form button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.result {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.copy-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.copy-container button {
  padding: 5px 10px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}

.copy-container v-icon {
  font-size: 24px;
}
</style>
